import { useEffect } from 'react';

export function useScreenResize(callback: () => void) {
  useEffect(() => {
    window.addEventListener('resize', callback);
  });
}
